"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YEAR = void 0;
exports.YEAR = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:YEAR not implemented');
    },
};
//# sourceMappingURL=year.js.map